export default __webpack_public_path__ + "static/media/gallery_06.b2508974.jpg";